<template>
  <div class="text" :class="{ 'custom-input' : customInput, row : hasRowClass }">
    <fa v-if="faClass" :fa-class="faClass" />

    <div class="input-inner">
      <div v-if="label" :class="getLabelClass">
        {{ $t(label) }}
      </div>

      <b-form-input :name="name"
                    id="input-modal"
                    :placeholder="$t(placeholder)"
                    v-model="val"
                    :required="required"
                    :state="state"
                    :type="type"
                    :customInput="customInput"
                    :min="min"
                    :max="max"
                    :readonly="readOnly"
                    :pattern="pattern"
                    :maxlength="maxLength"
                    :mask="mask"
                    v-mask="currentMask"

      />
      <label id="helpLabel" v-if="currentHelp != ''" for="input-modal">{{ currentHelp }}</label>
    </div>

    <error v-if="displayError">
      {{ errorMessage }}
    </error>
  </div>
</template>

<script>
import fa from '@/components/global/icon/fontAwesome'
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input'
import error from '@/components/frontoffice/form/error'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import VueMask from 'v-mask'

export default {
  components: {
    fa,
    bFormInput,
    error
  },

  mixins: [formMethods],

  props: {
    customInput: {
      type: Boolean,
      default: true
    },
    max: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    mask: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true
    },
    faClass: String,
    label: String,
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 999
    },
    state: {
      type: Boolean,
      default: null
    },
    help: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      val: this.value,
      displayError: false,
      errorMessage: '',
      currentMask: this.mask,
      currentHelp: this.help
    }
  },

  computed: {
    hasRowClass () {
      return [
        'offline_home',
        'online_booking_completion',
        'travellers',
        'home_booking_duplicate'
      ].includes(this.$route.name)
    },

    pattern () {
      return this.type === 'tel' ? '^\\+?\\s*(\\d+\\s?){8,}$' : null
    }
  },
  watch: {
    value (newVal) {
      this.val = newVal
    },

    val (newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    setMask(mask){
      this.currentMask = mask;
    },
    setHelp(help){
      this.currentHelp = help;
    }
  }
}
</script>

<style scoped lang="scss">
  #helpLabel{

    font-size: small;
  }
</style>
